import {ChangeDetectionStrategy, Component, Input} from '@angular/core';
import {UnitShort} from "@common-module/modelinterfaces/unit-short.model";
import {UnitState} from "@common-module/modelinterfaces/unit-state.model";
import {UnitGroupView} from "@common-module/modelinterfaces/user-unit-groups.model";
import { UnitStatusIconComponent } from '../unit-status-icon/unit-status-icon.component';
import { NgClass } from '@angular/common';
import { MatIcon } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';
import { ShortUnitStateInfoComponent } from '../short-unit-state-info/short-unit-state-info.component';

@Component({
    selector: 'app-unit-list-option',
    templateUrl: './unit-list-option.component.html',
    styleUrls: ['./unit-list-option.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [UnitStatusIconComponent, NgClass, MatIcon, MatTooltip, ShortUnitStateInfoComponent]
})
export class UnitListOptionComponent {

  readonly DEFAULT_COLOR = '#2b8cf7';

  @Input() timeZone = 'UTC';
  @Input() unit: UnitShort;
  @Input() unitState: UnitState;
  @Input() unreadNotificationCount = 0;
  @Input() highlight = false;
  @Input() unitGroupView: UnitGroupView | undefined;
}
